import css from './modal.css'

var pane, cont, head, title, reset, place, modal, focus
  
export function open(node) {
  if ( !pane) {
    pane = document.createElement('div')
    pane.classList.add('ModalPane')

    cont = document.createElement('div')
    pane.appendChild(cont)

    head = document.createElement('header')
    cont.appendChild(head)

    title = document.createElement('span')
    title.classList.add('title')
    title.textContent = 'Title'
    head.appendChild(title)

    reset = document.createElement('span')
    reset.classList.add('icons-reset-white')
    head.appendChild(reset)

    reset.addEventListener('click', doClose)

    place = document.createElement('div')
    place.classList.add('hidden')
  }

  if (modal) {
    throw new Error('modal already open')
  }
  modal = node

  focus = document.activeElement

  modal.parentNode.insertBefore(place, modal)
  cont.appendChild(modal)

  title.textContent = modal.getAttribute('data-title')

  document.body.appendChild(pane)
}

function doClose() {
 
  if ( !modal) {
    throw new Error('modal is not open')
  }
  
  place.parentNode.insertBefore(modal, place)
  place.parentNode.removeChild(place)
  
  document.body.removeChild(pane)
  setTimeout(focus.focus(), 0)
  modal = false
}

export function close() {
  doClose();
}
